import { infiniteQueryOptions } from "@tanstack/react-query";
import { retrieveMailIntake } from "@/lib/data/requests/mail-intake";
import { isMailIntakeActive } from "@/lib/data/schemas/mail-intake";
import { retrieveFiles } from "@/lib/data/requests/files/canonical-files";
import { queryKeys } from "@/lib/data/static/query-keys";

export const mailIntakeQueryOptions = (firmId: string, batchId?: string) =>
  infiniteQueryOptions({
    queryKey: [queryKeys.mailIntake, firmId, batchId],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => retrieveMailIntake(batchId, pageParam),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    refetchInterval: (query) =>
      query.state.status === "error" ||
      query.state.data?.pages.some((page) => page.data.some(isMailIntakeActive))
        ? 2000
        : false,
  });

export const mailFilingFoldersOptions = (
  matterId?: string,
  parentId?: string,
) =>
  infiniteQueryOptions({
    queryKey: [queryKeys.files, "mail-filing-folders", matterId, parentId],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) =>
      retrieveFiles(
        parentId ? { parentId } : { scope: "matter", matterId: matterId ?? "" },
        pageParam,
      ),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    enabled: !!matterId,
  });
